export default __webpack_public_path__ + "static/media/starbuck-pickup.6dc9d1d1.webp";